export const SignalingEvents = {
  // Conexión y salas
  JOIN_ROOM: 'room:join',
  ROOM_JOINED: 'room:joined',
  PEER_CONNECTED: 'peer:connected',
  PEER_DISCONNECTED: 'peer:disconnected',
  ROOM_FULL: 'room:full',
  
  // Negociación WebRTC
  SDP_OFFER: 'webrtc:offer',
  SDP_ANSWER: 'webrtc:answer',
  ICE_CANDIDATE: 'webrtc:ice-candidate',
  
  // Tele-control remoto
  REMOTE_COMMAND: 'command:remote',
  REMOTE_COMMAND_ACK: 'command:ack',
  
  // Apoyos Clínicos y Metrónomo
  CLINICAL_AID: 'clinical:aid',
  DISMISS_CLINICAL_AID: 'clinical:dismiss',
  
  // Pizarra virtual sobre snapshot
  WHITEBOARD_UPDATE: 'whiteboard:update',
  WHITEBOARD_CLEAR: 'whiteboard:clear',
  
  // Telemetría y Chat
  GPS_UPDATE: 'telemetry:gps',
  DEVICE_STATUS: 'telemetry:device',
  CHAT_MESSAGE: 'chat:message',
  
  // Transcripción y Traducción en Tiempo Real (IA / Faster-Whisper)
  TRANSCRIPTION_UPDATE: 'transcription:update',
  TRANSCRIPTION_TOGGLE: 'transcription:toggle',
  
  // Ciclo de vida de llamada
  CALL_ENDED: 'call:ended',
  SIGNALING_ERROR: 'error:signaling'
} as const;

export type SignalingEvent = typeof SignalingEvents[keyof typeof SignalingEvents];

export enum RemoteCommandType {
  TORCH_ON = 'TORCH_ON',
  TORCH_OFF = 'TORCH_OFF',
  CAMERA_SWITCH = 'CAMERA_SWITCH',
  CAMERA_ZOOM = 'CAMERA_ZOOM',
  METRONOME_START = 'METRONOME_START',
  METRONOME_STOP = 'METRONOME_STOP',
  SNAPSHOT_REQUEST = 'SNAPSHOT_REQUEST'
}

export const WebRtcConstraints = {
  // Optimizado para sensores móviles (Android/iOS) tanto en orientación vertical como horizontal
  VIDEO_LOW_LATENCY: {
    width: { ideal: 1280, max: 1920 },
    height: { ideal: 720, max: 1080 },
    frameRate: { ideal: 30, max: 30 }
  },
  AUDIO_CLINICAL: {
    echoCancellation: true,
    noiseSuppression: true,
    autoGainControl: true
  }
} as const;
